import { useContext, useEffect, useState } from "react";
import { UserStore } from "../..";
import BreadCrumbs from "../../components/breadcrumsb";
import { PageContainer } from "../../components/page";
import { useNavigate } from "react-router";
import { runAuthHandler } from "../util";
import { observer } from "mobx-react";
import ScheduledNotificationsContainer from "./ScheduledNotificationsContainer";
import { getScheduledNotifications } from "../../api/new-api";

const fetchScheduledNotificationHistory = async ({
  setData,
  setLoading,
  setError,
}: {
  setData: any;
  setLoading: any;
  setError: any;
}) => {
  setError("");
  setLoading(true);
  try {
    const res = await getScheduledNotifications();
    if (res.data) {
      setData(res.data);
    } else {
      setError("Error getting scheduled notifications");
    }
  } catch (error) {
    setError("Error getting scheduled notifications");
  } finally {
    setLoading(false);
  }
};

const ScheduledNotificationsPage = () => {
  const userStore = useContext(UserStore);
  const { selectedVenue } = userStore;
  const navigate = useNavigate();

  const [schedNotificationLoading, setSchedNotificationLoading] =
    useState(true);
  const [schedNotificationError, setSchedNotificationError] = useState<any>("");
  const [schedNotificationData, setSchedNotificationData] = useState<any>([]);

  const refetch = () => {
    fetchScheduledNotificationHistory({
      setData: setSchedNotificationData,
      setLoading: setSchedNotificationLoading,
      setError: setSchedNotificationError,
    });
  };

  useEffect(() => {
    runAuthHandler({ userStore, navigate });
    refetch();
  }, [selectedVenue]);

  return (
    <PageContainer>
      <BreadCrumbs
        routes={[
          { path: "/home", breadcrumbName: "Home" },
          {
            path: "/player-communications",
            breadcrumbName: "Player Messaging",
          },
        ]}
      />
      <div className="text-center text-3xl mb-2 font-bold">
        Scheduled Notifications
      </div>

      <div>
        <ScheduledNotificationsContainer
          data={schedNotificationData}
          loading={schedNotificationLoading}
          error={schedNotificationError}
          direction="row"
          refetch={refetch}
        />
      </div>
    </PageContainer>
  );
};

export default observer(ScheduledNotificationsPage);
